



document.addEventListener('DOMContentLoaded', function() {
  const lightbox = document.getElementById('sn-lightbox');
  const lightboxVideo = document.getElementById('sn-lightbox-video');
  const closeBtn = document.querySelector('.sn-close-lightbox');
  const videoCards = document.querySelectorAll('.sn-video-card');

  videoCards.forEach(card => {
    card.addEventListener('click', function() {
      // Obtener la URL del video de la tarjeta seleccionada
      const videoSource = this.querySelector('source').src;
      
      // Pasar la URL al video del Lightbox y mostrarlo
      lightboxVideo.querySelector('source').src = videoSource;
      lightboxVideo.load();
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden'; // Bloquea el scroll del fondo
    });
  });

  // Cerrar al hacer clic en la X
  closeBtn.addEventListener('click', function() {
    closeLightbox();
  });

  // Cerrar al hacer clic fuera del video
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });

  function closeLightbox() {
    lightbox.style.display = 'none';
    lightboxVideo.pause(); 
    lightboxVideo.src = ""; // Mejor limpiar el atributo src directamente del video
    lightboxVideo.load(); // Forzar la recarga para que el navegador "olvide" el video anterior
    document.body.style.overflow = 'auto';
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const pageClass = document.querySelector('.b-product'); //si solo quieres la home poner b-index  y cambiar los valores aplicarestilos, hay un custom liquid que esta oculto debes dar mostrar en el panel en caso de querer forzar el fondo del menu
  const anchorColors = document.querySelectorAll('.header__menu-item');
  const logo = document.querySelector('.header__heading-logo');
  const logoOriginal = logo ? logo.src : '';
  const logoNegro = "URL_DE_TU_LOGO_NEGRO_AQUI"; // REEMPLAZA ESTA URL

  let divCreated = false;

  // Función unificada para aplicar estados
  const aplicarEstilos = (colorTexto, colorFondo, aplicarLogoNegro) => {
    header.style.backgroundColor = colorFondo;
    
    anchorColors.forEach(anchor => {
      anchor.style.color = colorTexto;
    });

    if (logo) {
      if (aplicarLogoNegro) {
        logo.style.filter = 'brightness(0)';
      } else {
        logo.style.filter = 'none';
        logo.src = logoOriginal;
      }
    }
  };

  // 1. Lógica de Scroll (Detecta al cargar y al mover el scroll)
  const updateScroll = () => {
    // Si estamos haciendo hover, no permitimos que el scroll cambie el diseño
    if (header.classList.contains('goals-hover-active')) return;

    if (window.scrollY > 40) {
      aplicarEstilos('#ffffff', '#152622', false); // Scroll activo: Negro
    } else {

      if(!pageClass){
       // aplicarEstilos('#ffffff', '#152622', false); 
        aplicarEstilos('#ffffff', 'transparent', false); // Top: Transparente
      }else{
        //aplicarEstilos('#ffffff', 'transparent', false); // Top: Transparente
        aplicarEstilos('#ffffff', '#152622', false); 
      }

      
    }
  };

  window.addEventListener('scroll', updateScroll);
  updateScroll(); // Ejecuta al cargar para evitar el problema de recarga

  // 2. Lógica de Hover (Delegación de eventos)
  document.addEventListener('pointerover', (e) => {
    const goalsMenu = e.target.closest('.sn-goals-menu');

    if (goalsMenu) {
      if(!divCreated){
        const menuUl = goalsMenu.querySelector('.tmenu_submenu_type_mega');
      
        if (menuUl) {
          // 1. Creamos el nuevo div contenedor
          const innerWrapper = document.createElement('div');
          innerWrapper.className = 'mega-menu-inner-container';
          
          // 2. Movemos todos los hijos (LI) del UL dentro del nuevo DIV
          // Usamos un bucle while para mover los nodos uno a uno
          while (menuUl.firstChild) {
            innerWrapper.appendChild(menuUl.firstChild);
          }
          
          // 3. Insertamos el nuevo DIV dentro del UL original
          menuUl.appendChild(innerWrapper);
          
          // 4. Marcamos la bandera para que no ocurra de nuevo
          divCreated = true;
          
          // Limpiamos los estilos en línea que puedan estar estorbando
          menuUl.style.width = '100%';
          menuUl.style.display = 'block'; 

          // Seleccionamos todos los contenedores de imagen del menú
          const imageContainers = document.querySelectorAll('.tmenu_image--above');

          imageContainers.forEach(container => {
            // Verificamos si ya inyectamos el botón para no duplicarlo
            if (!container.querySelector('.custom-btn-link')) {
              
              const spanText = container.querySelector('.tmenu_item_text');
              
              // Creamos el elemento anchor (botón)
              const btn = document.createElement('a');
              btn.className = 'custom-btn-link';
              btn.innerText = 'Shop'; // Texto de tu botón
              btn.href = container.parentElement.href; // Copia el link del contenedor padre
              
              // Lo insertamos después del span
              if (spanText) {
                spanText.after(btn);
              } else {
                container.appendChild(btn);
              }
            }
          });
        }
      }

      header.classList.add('goals-hover-active');
      aplicarEstilos('#152622', '#e7e9e3', true); // Hover: Crema      
    }
  });

  document.addEventListener('pointerout', (e) => {
    const goalsMenu = e.target.closest('.sn-goals-menu');

    if (goalsMenu) {
      header.classList.remove('goals-hover-active');
      updateScroll(); // Al quitar el mouse, vuelve al estado correcto del scroll
    }
  });

});

